// Sivuston yhteiset asetukset ja yhteystiedot.

export const site = {
  contact: {
    email: "anton@hetkicompany.com",
    phone: "+358 40 141 3605",
    // WhatsApp-numero — sama kuin puhelin. wa.me-linkki rakennetaan tästä.
    whatsapp: "+358 40 141 3605",
    website: "hetkicompany.com",
    address: ["Josafatinkatu 9 lh 64", "00510 Helsinki, Finland"],
  },
  social: {
    instagram: "https://www.instagram.com/hetkicompany",
    // Vimeo ei ole julkisessa käytössä tällä hetkellä — ei näytetä sivulla.
    vimeo: "https://vimeo.com/hetkicompany",
  },
  momentum: {
    url: "https://momentum.hetkicompany.com",
    description:
      "Momentum on Hetken kehittämä työkalu tiimeille, joilla on monta lankaa käsissä.",
  },
  copyright: "© Hetki Company Oy 2026 · Helsinki",
};
